import { render, staticRenderFns } from "./LogoGloboTextSection.vue?vue&type=template&id=6aa68565"
import script from "./LogoGloboTextSection.vue?vue&type=script&lang=ts"
export * from "./LogoGloboTextSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoGloboTextSection.vue?vue&type=style&index=0&id=6aa68565&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports